import React, { useState } from "react";
import cn from "classnames";
import styles from "./OrganizationTable.module.css";
import SearchInput from "../common/SearchInput";

function OrganizationTable({ org, onSearchChange, onNew, handleUpdateClick, handleDeleteClick }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const itemsPerPage = 12;

  const totalPages = Math.max(1, Math.ceil(org.length / itemsPerPage));
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = org.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (n) => {
    if (n < 1 || n > totalPages) return;
    setCurrentPage(n);
  };

  const onSearch = (q) => {
    setSearchQuery(q);
    setCurrentPage(1);
    onSearchChange?.(q);
  };

  return (
    <div className={styles.tableOuterContainer}>
      <div className="page-toolbar">
        <h2 className="page-toolbar-title">
          <i className="bi bi-buildings" style={{ color: "var(--accent)" }} />
          Organizations
          <span className="toolbar-count">{org.length.toLocaleString()}</span>
        </h2>
        <div className="page-toolbar-actions">
          <SearchInput
            value={searchQuery}
            onChange={onSearch}
            placeholder="Search by name, email, CIK, wallet..."
          />
          {onNew && (
            <button type="button" className="btn btn-accent" onClick={onNew}>
              <i className="bi bi-plus-lg" /> New organization
            </button>
          )}
        </div>
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>CIK</th>
            <th>Type</th>
            <th>Wallet</th>
            <th>Status</th>
            <th className={styles.actionCol}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((o) => (
              <tr key={o.id}>
                <td><span className={styles.orgNameCell}>{o.name}</span></td>
                <td><span className={styles.emailIdCell}>{o.emailId || "—"}</span></td>
                <td className="mono">{o.externalId || "—"}</td>
                <td><span style={{ textTransform: "capitalize" }}>{o.type || "—"}</span></td>
                <td>
                  {o.walletAddress ? (
                    <span className="mono" title={o.walletAddress} style={{ color: "var(--text-secondary)" }}>
                      {o.walletAddress.slice(0, 8)}…{o.walletAddress.slice(-6)}
                    </span>
                  ) : <span className="muted">—</span>}
                </td>
                <td>
                  <span className={cn("status-pill", {
                    "status-active":  o.status?.toLowerCase() === "active",
                    "status-pending": o.status?.toLowerCase() === "pending",
                  })}>
                    {o.status || "—"}
                  </span>
                </td>
                <td className={styles.actionCol}>
                  <div className={styles.actionRow}>
                    <button
                      type="button"
                      className={styles.iconAction}
                      onClick={(e) => { e.stopPropagation(); handleUpdateClick(o.id); }}
                      title="Edit"
                      aria-label={`Edit ${o.name}`}
                    >
                      <i className="bi bi-pencil-square" />
                    </button>
                    <button
                      type="button"
                      className={cn(styles.iconAction, styles.iconActionDanger)}
                      onClick={(e) => { e.stopPropagation(); handleDeleteClick(o.id); }}
                      title="Delete"
                      aria-label={`Delete ${o.name}`}
                    >
                      <i className="bi bi-trash3" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7} style={{ textAlign: "center", padding: 32 }} className="muted">
                No organizations found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="pagination" style={{ marginTop: 14 }}>
          <button className="arrow-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>&larr;</button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => handlePageChange(i + 1)}
              className={cn("page-button", { active: currentPage === i + 1 })}
            >{i + 1}</button>
          ))}
          <button className="arrow-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>&rarr;</button>
        </div>
      )}
    </div>
  );
}

export default OrganizationTable;
